import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { lastValueFrom, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiUrlService } from './api-url.service';
import {
  FarmaIaMetadataEntry,
  FarmaIaMetadataResponse,
  FarmaIaCostDashboardResponse,
  FarmaIaReportingQuery,
  FarmaIaTrainingEntry,
  FarmaIaTrainingResponse,
  TrainingUpdateRequest,
  UsageDataEntry,
  UsageDataResponse
} from '../models/interfaz';

@Injectable({
  providedIn: 'root'
})
export class HermesService {
  constructor(private apiUrl: ApiUrlService, private http: HttpClient) {}

  /**
   * Obtiene el resumen de costes, evolución diaria y top farmacias de FarmaIA.
   */
  getCostDashboard(query: FarmaIaReportingQuery = {}): Observable<FarmaIaCostDashboardResponse> {
    return this.http.get<FarmaIaCostDashboardResponse>(this.apiUrl.hermesCostDashboardApi, {
      params: this.toQueryParams(query)
    });
  }

  /**
   * Obtiene los metadatos e interacciones registradas con FarmaIA.
   */
  getMetadata(query: FarmaIaReportingQuery = {}): Observable<FarmaIaMetadataResponse> {
    return this.http.get<FarmaIaMetadataResponse>(this.apiUrl.hermesMetadataApi, {
      params: this.toQueryParams(query)
    });
  }

  /**
   * Obtiene el catálogo de preguntas y queries SQL para entrenamiento y validación.
   */
  getTrainingData(): Observable<FarmaIaTrainingEntry[]> {
    return this.http
      .get<FarmaIaTrainingResponse>(this.apiUrl.hermesTrainingApi)
      .pipe(map((response) => response.data ?? []));
  }

  /**
   * Actualiza y valida la query SQL de un registro de entrenamiento.
   */
  async updateSQLTraining(data: TrainingUpdateRequest): Promise<void> {
    await lastValueFrom(
      this.http.put<void>(this.apiUrl.hermesTrainingUpdateApi, data)
    );
  }

  /**
   * Lanza la generación y persistencia de embeddings para queries correctas.
   */
  embedTraining(): Observable<unknown> {
    return this.http.get(this.apiUrl.hermesTrainingEmbedApi);
  }

  /**
   * Obtiene los datos de uso de clientes (para compatibilidad).
   */
  getUsageData(): Observable<UsageDataEntry[]> {
    return this.http
      .get<UsageDataResponse>(this.apiUrl.usageDataApi)
      .pipe(map((response) => response.data ?? []));
  }

  private toQueryParams(query: FarmaIaReportingQuery): HttpParams {
    let params = new HttpParams();
    for (const [key, value] of Object.entries(query)) {
      if (value?.trim()) params = params.set(key, value.trim());
    }
    return params;
  }
}
